import {midPoint, Vector} from "./vector"
import {splitTriangle, Triangle} from "./geometry"

/**
 * Height of an equilateral triangle with sides of length 1.
 */
export const baseTriangleHeight: number = Math.sqrt(3) / 2

/**
 * The top-level triangle in the Sierpinski pattern. We choose an equilateral triangle with sides of length 1, a base
 * parallel to the x axis and a top vertex at the origin.
 */
export const baseTriangle: Triangle = {
    left: [-0.5, baseTriangleHeight],
    top: [0, 0],
    right: [0.5, baseTriangleHeight]
}

const generateSierpinskiRecur = (depth: number, parent: Triangle): Array<Triangle> => {
    if (depth === 0) {
        return [parent]
    } else {
        const {topChild, leftChild, rightChild} = splitTriangle(parent)

        return generateSierpinskiRecur(depth - 1, topChild)
            .concat(generateSierpinskiRecur(depth -1, leftChild))
            .concat(generateSierpinskiRecur(depth -1, rightChild))
    }
}

/**
 * Generate coordinates for the smallest scale triangles in a Sierpinski triangle pattern. Depth is the number of
 * recursive levels.
 */
export const generateSierpinski = (depth: number): Array<Triangle> => generateSierpinskiRecur(depth, baseTriangle)



// WEBPACK FOOTER //
// ./src/sierpinski.ts